import { AppRoutes } from '@core/AppRoutes'
import { store } from '@core/Store'
import { setResetTimestamp } from '../Store'
import { trackVisionOpened } from '@core/Areas/SkyVideoPlayer/analytics'
import { appHistory } from '@core/Utils/routing/history'

export const navigateToSkyRacePage = () => {
  const skyRaceCardRoute = AppRoutes.RaceCardSky

  trackVisionOpened({ openLocation: 'sky-page', channel: 'Sky1' })

  if (window.location.pathname === skyRaceCardRoute) {
    store.dispatch(setResetTimestamp())
  } else {
    appHistory.push(skyRaceCardRoute)
  }
}
